import PeriodSelector from "components/PeriodSelector";
import ToolbarTitle from "design/components/texts/ToolbarTitle";
import Tabs from "design/components/toolbar/Tabs";
import ToolbarContainer from "design/components/toolbar/ToolbarContainer";
import Center from "design/layouts/Center";
import Right from "design/layouts/Right";
import SplitView from "design/layouts/SplitView";
import { t } from "i18next";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useCurrentUser from "qpr-base/context/UserContext";
import useLink from "qpr-base/hooks/useLink";
import { getFileApiURL } from "qpr-base/utils/url-utils";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useIconStyles = makeThemedStyles("GenericToolbarIcon", (theme) => ({
  root: {
    marginLeft: 0,
    marginRight: "15px",
    marginTop: 0,
    width: "50px",
    height: "50px",
    backgroundImage: `url(${getFileApiURL(
      "/api/files/?file=/icons/navitems/ManageWorkflows.svg"
    )})`,
    backgroundSize: "50px 50px",
  },
}));

const WorkflowAdminToolbar = (props: { selected?: string }) => {
  const ctx = useAppContext();
  const link = useLink();
  const user = useCurrentUser();
  const iconstyles = useIconStyles();
  return (
    <ToolbarContainer>
      <SplitView partCnt={3}>
        <ToolbarTitle>
          <span className={iconstyles.root}></span>
          {t("Workflow Admin")}
        </ToolbarTitle>
        <Center>
          <Tabs
            onChange={(value) => {
              link({
                page: value,
              });
            }}
            selected={props.selected || ctx.page || ""}
            options={[]}
          />
        </Center>
        <Right>
          <PeriodSelector />
        </Right>
      </SplitView>
    </ToolbarContainer>
  );
};

export default WorkflowAdminToolbar;
